import ApiService from '../../../../shared/services/ApiService';

export default{
    getDepartments() {
        return ApiService.get('company-departments');
    },
    createNewDepartments(data) {
        return ApiService.post('company-department-multi', data);
    },
    deleteDepartment(id){
        return ApiService.delete(`company-departments/${id}`);
    },
    updateDepartment(id, data){
        return ApiService.put(`company-departments/${id}`, data);
    },
    showDepartment(department){
        return ApiService.get(`company-departments/${department}`)
    },
    addMemberToDepartment(data){
        return ApiService.post('departments/members/add', data);
    },
    getDepartmentMembers(did){
        return ApiService.get(`departments/${did}/members`)
    },

    getDepartmentsMemberList(did){
        return ApiService.get(`departments/${did}/members/group`)
    },

    updateCompanySettings(data){
        return ApiService.post('company-settings', data);
    },

    getDepartmentManagers(did){
        return ApiService.get(`company-departments/${did}/managers`)
    },

    addManagersToDepartment(id, data){
        return ApiService.post(`company-departments/${id}/managers`, data);
    },

    deleteManagerFromDepartment(companyId, mangerId){
        return ApiService.delete(`company-departments/${companyId}/managers/${mangerId}`)
    }
}